export const MachineryData = [
  {
    fileName: "sounds/transport_wagon.mp3",
    breaks: 5000,
    name: "Transport wagon",
    volume: 50,
  },
  {
    fileName: "sounds/chopper.mp3",
    breaks: 0,
    name: "Chopper",
    volume: 50,
  },
  {
    fileName: "sounds/tractor.m4a",
    breaks: 2000,
    name: "Tractor",
    volume: 50,
  }
];

export const EnvironmentData = [
  {
    fileName: "sounds/thunder.mp3",
    breaks: 0,
    name: "ThunderStorm",
    volume: 50,
  },
  {
    fileName: "sounds/wind-in-maize.mp3",
    breaks: 0,
    name: "Wind in the maize field",
    volume: 50,
  },
  {
    fileName: "sounds/church-bell.mp3",
    breaks: 15000,
    name: "Church in a distance",
    volume: 30,
  },
];

export const FarmLifeData = [
  {
    fileName: "sounds/small-dog-barking.mp3",
    breaks: 3000,
    name: "Farm Dog",
    volume: 100,
  },
  {
    fileName: "sounds/cows.mp3",
    breaks: 5000,
    name: "Cows",
    volume: 50,
  },
  {
    fileName: "sounds/cowbells.mp3",
    breaks: 10000,
    name: "CowBells",
    volume: 20,
  },
  {
    fileName: "sounds/rooster.wav",
    breaks: 7000,
    name: "Rooster",
    volume: 20,
  },
  {
    fileName: "sounds/chicken.mp3",
    breaks: 6000,
    name: "Chicken",
    volume: 20,
  },
];

export const AddTheSoundOfMissingDigitalizationData = [
  {
    fileName: "sounds/phone.mp3",
    breaks: 3000,
    name: "No fleet management",
    volume: 40,
  },
  {
    fileName: "sounds/broken-isoxml.mp3",
    breaks: 5000,
    name: "Broken ISOXML",
    volume: 100,
  },
  {
    fileName: "sounds/no-apis.mp3",
    breaks: 1000,
    name: "Lack of interfaces with the authorities",
    volume: 100,
  },
  {
    fileName: "sounds/wrong-application-map.mp3",
    breaks: 15000,
    name: "Spraying a wrong application map",
    volume: 100,
  },
  {
    fileName: "sounds/usb-data-exchange.mp3",
    breaks: 3000,
    name: "Still using USB sticks",
    volume: 100,
  },
];
